import { Box, Grid, Typography, Paper } from '@mui/material';
import React from 'react';
import { JobReportData } from './JobReportData';
import { WithSmallScreen } from '../common/WithSmallScreen';
import { getJobReportConfig } from './config';

export const JobReportSummary = WithSmallScreen(({ record, id, isSM }) => {
  const jobReportConfig = getJobReportConfig({ record, isSM })[id];

  return (
    <Box id={`${id}__box`}>
      <Grid
        container
        spacing={2}
        direction={{
          xs: 'column',
          sm: 'row',
          md: 'column',
          lg: 'row',
        }}
      >
        {jobReportConfig?.summary.map((info) => {
          return (
            <Grid item xs={12} sm={12} md={4}>
              <Box p={2}>
                <Box mb={0.5}>
                  <Typography variant="h3">{info.name}</Typography>
                </Box>
                {info.value?.map(
                  ({ label, data, className = '', dataClassName = '', labelClassName = '' }) => (
                    <JobReportData
                      key={label}
                      id={id}
                      label={label}
                      data={data}
                      direction={{
                        xs: 'column',
                        sm: 'column',
                        md: 'row',
                        lg: 'row',
                        xl: 'row',
                      }}
                      className={`myOdu__smaller ${className}`}
                      {...(dataClassName && {
                        dataClassName,
                      })}
                      {...(labelClassName && {
                        labelClassName,
                      })}
                    />
                  ),
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
});
